import { RobotOutlined } from '@ant-design/icons'
import { Button } from 'aa_common/front-end/antd'
import { Col, Collapse as AntCollapse, Image, Row, Typography } from 'antd'
import { getNs } from 'common/i18n-config'

import { Card, CardContent, CardIcon, Collapse } from '../styles'

const { Text, Title } = Typography
const { Panel } = AntCollapse

const { t, useNsReady } = getNs(['components/organisms/assets/asset-form'])
export const AISubmittedResult = () => {
  useNsReady()
  return (
    <Card>
      <Row align="middle" justify="space-between" style={{ marginBottom: '24px' }}>
        <Col span={24}>
          <Row align="middle" gutter={12}>
            <Col>
              <CardIcon>
                <RobotOutlined style={{ fontSize: '16px', color: 'white' }} />
              </CardIcon>
            </Col>
            <Col>
              <div>
                <Title level={5}>{t('ai_analysis_result')}</Title>
                <Text type="secondary" style={{ fontSize: '14px' }}>
                  {t('ai_analysis_result_description')}
                </Text>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Content Card */}
      <CardContent>
        <Row gutter={24} justify="space-between">
          {/* Image */}
          <Col span={6}>
            <Image width={96} height={96} src="" /> {/* TODO: Add image url */}
          </Col>

          {/* Details */}
          <Col span={17}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div>
                  <Text type="secondary">{t('name')}</Text>
                  <Title level={5}>{/* TODO: Add asset name */}</Title>
                </div>
              </Col>

              <Col span={24}>
                <div>
                  <Text type="secondary">{t('asset_name_by_katakana')}</Text>
                  <Title level={5}>{/* TODO: Add asset name by katakana */}</Title>
                </div>
              </Col>

              <Col span={12}>
                <div>
                  <Text type="secondary">{t('asset_category')}</Text>
                  <Title level={5} style={{ color: '#3b7de9' }}>
                    {/* TODO: Add asset category */}
                  </Title>
                </div>
              </Col>

              <Col>
                <div>
                  <Text type="secondary">{t('service_life')}</Text>
                  <Title level={5} style={{ color: '#3b7de9' }}>
                    {/* TODO: Add service life */}
                  </Title>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardContent>

      <Collapse collapsible="header">
        <Panel header={t('show_decision_rationale')} key="1">
          <Text>{t('decision_based_on_input_request_more_info')}</Text>
        </Panel>
      </Collapse>

      <Row gutter={16}>
        <Col span={12}>
          <Button block>{t('reflect_to_form')}</Button>
        </Col>
        <Col span={12}>
          <Button color="grey" block>
            {t('try_again')}
          </Button>
        </Col>
      </Row>
    </Card>
  )
}
